import { Subject } from 'rxjs';

export interface INotification {
  text?: string;
  button?: string;
  //component?: any;
  type: NotificationType;
  //data?: any;
  duration?: number;
}

export enum NotificationType {
  success = 1,
  error = 2,
  warning = 3,
}

export class Notification implements INotification {
  text: string;
  button: string;
  type: NotificationType;
  duration: number;
  dismissed$: Subject<NotificatioDismiss>;

  constructor() {
    this.dismissed$ = new Subject<NotificatioDismiss>();
  }

  show(): void {}

  dismiss(dismissedByAction: boolean): void {
    this.dismissed$.next({ dismissedByAction: dismissedByAction, notification: this });
  }
}
export class NotificationRef {
  public notification: Notification;

  constructor(notification: Notification) {
    this.notification = notification;
  }

  afterDismissed(): Subject<NotificatioDismiss> {
    return this.notification.dismissed$;
  }
}

export class NotificatioDismiss {
  dismissedByAction: boolean;
  notification: Notification;

  constructor(dismissedByAction: boolean) {
    this.dismissedByAction = dismissedByAction;
  }
}
